<template>
    <div>
        <div style="display: flex;">
            
            <div style="width: 400px;">
                <div style="width: 400px;margin-bottom: 15px;" v-if="hasPromotion">首充优惠仅有一次，建议充值年卡更划算</div>
                <el-radio-group v-model="cardType" style="display: flex;flex-direction: column;align-items: flex-start;"
                    :disabled="qrCodeImage!=''" >
                    <el-radio :label="1" style="margin: 0px 15px 15px 15px;">月卡(28元)<span style="color: red;" v-if="hasPromotion">首充优惠价:20元</span><span style="color: red;" v-if="cardType==1">{{ addDays }}</span></el-radio>
                    <el-radio :label="2" style="margin: 15px;">季卡(68元)<span style="color: red;" v-if="hasPromotion">首充优惠价:50元</span><span style="color: red;" v-if="cardType==2">{{ addDays }}</span></el-radio>
                    <el-radio :label="3" style="margin: 15px;">年卡(198元)<span style="color: red;" v-if="hasPromotion">首充6折优惠价:120元</span><span style="color: red;" v-if="cardType==3">{{ addDays }}</span></el-radio>
                    <el-radio :label="7" style="margin: 15px;">15元包100小时【见备注1】</el-radio>
                    <el-radio :label="5" style="margin: 15px;">18元电话提醒100次【见备注2】</el-radio>
                </el-radio-group>
                <div style="display: flex;align-items: center;margin-top: 10px;color: red;" v-if="isBind==0">
                    邀请码:<el-input v-model="couponCode" placeholder="没有可以不填" style="width: 150px"></el-input>
                </div>
            </div>
            <div style="width: 200px;height: 200px;border: #ccc 1px solid;line-height: 200px;" v-loading="loadingQR">
                <img :src="qrCodeImage" alt="QR Code" v-if="qrCodeImage!=''" style="width: 100%; height: 100%;">
                <div style="text-align: center;"><el-button type="success" @click="pay" v-if="qrCodeImage==''">下一步，微信支付</el-button></div>
            </div>
        </div>
        <div style="margin-top: 15px;">
            备注1：15元包100小时，仅登录软件时才开始计时，退出软件则停止计时。如果多台电脑同时使用会叠加计时<br><br>
            备注2：电话提醒次数无法独立使用，需在开通会员的前提下(月卡、年卡均可)才能使用，
            会员到期后，电话次数不会清零，后面再充值会员仍然可以继续使用。<br><br>
        </div>

    </div>
</template>

<script>
import QRCode from 'qrcode'; // 引入 qrcode 库
export default {
    name: 'UserPay',
    props: {
        isBind:{
            type:Number,
            default:0
        }
    },
    data() {
        return {
            loadingQR: false,
            qrCodeImage: '', // 用于存储生成的二维码图片: '',
            cardType: -1, // 选择的充值类型
            couponCode:'',
            addDays:'',
            hasPromotion:false,
            promotionNo:''
        }
    },
    mounted() {
       let promotion=localStorage.getItem('promotion')
         if((promotion||'')!=''){
                this.hasPromotion=true
                this.promotionNo=promotion
         }

    },
    created() {

    },
    methods: {
        selectCardType(e) {
            console.log(e)
            var that = this
            this.loadingQR = true
            let amount = 0
            if(!that.hasPromotion){//无活动
                if (e == 1) amount = 28
                if (e == 2) amount = 68
                if (e == 3) amount = 198
                if (e == 5) amount = 18
                if (e == 7) amount = 15
            }
            else{//双11活动或者后台赠送6折优惠
                if (e == 1) amount = 20
                if (e == 2) amount = 50
                if (e == 3) amount = 120
                if (e == 5) amount = 18
                if (e == 7) amount = 15 //包时
            }
            
            this.$post('/api/v9/pay', { amount: amount,couponCode:that.couponCode,promotion:that.promotionNo }).then(res => {
                console.log(res)
                this.loadingQR = false
                let qrUrl = res.qrUrl
                if (qrUrl == '') {
                    that.$message({
                        message: '获取二维码失败',
                        type: 'error'
                    });
                    return
                }
                if(!res.useCode && that.couponCode!=''){
                    that.$message({
                        message: '邀请码无效',
                        type: 'warning'
                    });
                }
                if(res.useCode){
                    let addDays=''
                    if(e==1) addDays='赠送5天'
                    if(e==2) addDays='赠送10天'
                    if(e==3) addDays='赠送30天'
                    that.addDays=addDays
                }
                QRCode.toDataURL(qrUrl, (err, url) => {
                    if (err) {
                        console.error('生成二维码失败:', err);
                        that.$message({
                            message: '生成二维码失败',
                            type: 'error'
                        });
                        this.loadingQR = false;
                        return;
                    }
                    this.qrCodeImage = url;
                    this.loadingQR = false;
                });
            })

        },
        pay(){
            if(this.cardType==-1){
                this.$message({
                    message: '请选择充值类型',
                    type: 'error'
                });
                return
            }
            this.selectCardType(this.cardType)
        }
    }
}
</script>

<style lang="scss" scoped></style>